export default {
  employee: {
    requestStats: [
      {
        value: 'all',
        text: 'all',
      },
      {
        value: 'pending',
        text: 'pending',
      },
      {
        value: 'cancelled',
        text: 'cancelled',
      },
      {
        value: 'completed',
        text: 'approvals',
      },
      {
        value: 'rejected',
        text: 'rejects',
      },
    ],
    months: [],
    years: [],
  },
  accounting: {
    requestStats: [
      {
        value: 'all',
        text: 'all',
      },
      {
        value: 'accounting',
        text: 'pending',
      },
      {
        value: 'cancelled',
        text: 'cancellations',
      },
      {
        value: 'completed',
        text: 'approvals',
      },
    ],
    months: [],
    years: [],
  },
  admin: {
    requestStats: [
      {
        value: 'all',
        text: 'all',
      },
      {
        value: 'pending',
        text: 'pending',
      },
      {
        value: 'accounting',
        text: 'aWaitingAccountantApproval',
      },
      {
        value: 'waiting_for_cancelled',
        text: 'waitingForCancelConfirmation',
      },
      {
        value: 'cancelled',
        text: 'cancellations',
      },
      {
        value: 'completed',
        text: 'approvals',
      },
      {
        value: 'rejected',
        text: 'rejects',
      },
    ],
    months: [],
    years: [],
  },
  hr: {
    requestStats: [
      {
        value: 'all',
        text: 'all',
      },
      {
        value: 'pending',
        text: 'pending',
      },
      {
        value: 'cancelled',
        text: 'cancellations',
      },
      {
        value: 'completed',
        text: 'approvals',
      },
    ],
    months: [],
    years: [],
  },
  report: {
    requestStats: [
      {
        value: 'default',
        text: 'choose',
      },
      {
        value: 'uploaded',
        text: 'Aktarılanlar Puantajlar',
      },
      {
        value: 'unuploaded',
        text: 'Aktarılmayanlar Puantajlar',
      }
    ],
    months: [],
    years: []
  },
};



// WEBPACK FOOTER //
// ./src/constants/filterOptionValues.js